const CTA_noPromo = () => {
  return (
    <div className="flex w-full py-16 flex-col gap-6 items-center shrink-0 flex-nowrap bg-gray-600 relative overflow-hidden">
      <div className="flex w-full max-w-[1280px] px-4 md:px-8 flex-col gap-6 items-center text-center shrink-0 flex-nowrap relative">
        <div className="flex flex-col gap-5">
          <h2 className="text-3xl md:text-4xl self-stretch shrink-0 basis-auto font-semibold text-white tracking-[-0.72px] relative text-center whitespace-nowrap">
            Transparent pricing
          </h2>
          <span className="flex w-full justify-center items-start shrink-0 basis-auto text-[20px] font-normal leading-[30px] text-white relative text-center">
            Only pay when you sell tickets
          </span>
        </div>
        <div className="w-full md:w-[344px] bg-gray-50 rounded-2xl p-6">
          <div className="flex flex-col items-center gap-2">
            <span className="text-3xl md:text-4xl font-semibold text-gray-900">5%</span>
            <span className="text-base text-gray-600">Platform fee per paid ticket*</span>
          </div>
        </div>
        <div className="text-left text-base md:text-lg text-white">
          <p className="font-semibold mb-2">Included for free:</p>
          <ul className="list-disc pl-5">
            <li>No platform fees on free tickets</li>
            <li>No monthly or annual fees</li>
            <li>All features included</li>
          </ul>
        </div>
        <p className="w-full max-w-[1080px] text-sm text-white text-left">
          * Stripe, our payment processor, typically applies a credit card fee of 2.9% plus 30 cents per transaction. This fee is separate from and in addition to Peatix's platform fee.
        </p>
      </div>
      <a 
        href="https://peatix.com/us/event/create" 
        className="bg-primary-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-primary-700 transition-colors"
      >
        Get started for free
      </a>
    </div>
  );
};

export default CTA_noPromo; 